import { AutoComplete, Checkbox, Col, Divider, Form, Input, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../../../context/AuthProvider';
import {
  setContract,
  updateContractWorkPlaceItem,
  updateEquipmentTab,
  updateField,
} from '../../../../../contextRedux/Contract/ContractModel';
import { RootState } from '../../../../../store';
import './CompanyDetailsTab';

const { Option } = AutoComplete;

const CompanyDetailsTab: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const id = useSelector((state: RootState) => state?.models?.contract?.id);
  const companyId = useSelector((state: RootState) => state?.models?.contract?.companyId);
  const reduxContract = useSelector((state: RootState) => state?.models?.contract);

  const offers = useSelector((state: RootState) => state.store.offer);
  const companies = useSelector((state: RootState) => state.store.company.data);
  const status = useSelector((state: RootState) => state?.store.statusContract.data);
  const accountSales = useSelector((state: RootState) => state?.store.user.data).filter((user: any) =>
    user?.userPermission?.rols?.includes('sales')
  );

  const { profile } = useAuth();
  const currentDate = moment().format('YYYY-MM-DD');

  const initialValues = {
    company: useSelector((state: RootState) => state?.models?.contract?.company),
    companyId: useSelector((state: RootState) => state?.models?.contract?.companyId),
    accountManager: useSelector((state: RootState) => state?.models?.contract?.accountManager),
    accountSale: useSelector((state: RootState) => state?.models?.contract?.accountSale),
    accountSaleId: useSelector((state: RootState) => state?.models?.contract?.accountSaleId),
    enumContractStatus: useSelector((state: RootState) => state?.models?.contract?.enumContractStatus),
    enumContractStatusId: useSelector((state: RootState) => state?.models?.contract?.enumContractStatusId),
    date: useSelector((state: RootState) => state?.models?.contract?.date),
    dateStart: useSelector((state: RootState) => state?.models?.contract?.dateStart),
    dateEnd: useSelector((state: RootState) => state?.models?.contract?.dateEnd),
    datePeriod: useSelector((state: RootState) => state?.models?.contract?.datePeriod),
    acquisitionType: useSelector((state: RootState) => state?.models?.contract?.acquisitionType),
    intervention: useSelector((state: RootState) => state?.models?.contract?.intervention),
    hasUnlimitedInterventions: useSelector((state: RootState) => state?.models?.contract?.hasUnlimitedInterventions),
    isExpedite: useSelector((state: RootState) => state?.models?.contract?.isExpedite),
    hasAutomaticExtension: useSelector((state: RootState) => state?.models?.contract?.hasAutomaticExtension),
    registrationNumber: useSelector((state: RootState) => state?.models?.contract?.registrationNumber),
    remarks: useSelector((state: RootState) => state?.models?.contract?.remarks),
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const handleSelectClient = (value: any) => {
    const company = companies.find((company: any) => company.name === value?.label);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      company: company,
      companyId: company?.id,
      accountManager: company?.accountManager,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
    dispatch(updateField({ field: 'company', value: company ?? null }));
    dispatch(updateField({ field: 'accountManagerId', value: company?.accountManager?.id ?? null }));
    dispatch(updateField({ field: 'accountManager', value: company?.accountManager ?? null }));
  };

  const handleSelectAccountSales = (value: string) => {
    const accountSale = accountSales?.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      accountSale: accountSale,
      accountSaleId: accountSale?.id,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'accountSaleId', value: accountSale?.id ?? null }));
    dispatch(updateField({ field: 'accountSale', value: accountSale ?? null }));
  };

  const handleSelectStatus = (value: string) => {
    const selectStatus = status.find((date: any) => date.name === value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      enumContractStatusId: selectStatus?.id,
      enumContractStatus: selectStatus,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'enumContractStatusId', value: selectStatus?.id ?? null }));
    dispatch(updateField({ field: 'enumContractStatus', value: selectStatus ?? null }));
  };

  const handleSelectClientOffer = (value: string) => {
    const offer = offers.data.find((o: any) => o?.number == value);
    dispatch(
      setContract({
        ...offer,
        id: null,
        offerId: offer?.id,
        contractLaborExtras: offer.offerLaborExtras,
        contractWorkPlaceItems: offer.offerWorkPlaceItems,
        enumContractStatusId: 1,
        enumContractStatus: { id: 1, name: 'Activ' },
        isExpedite: offer.isExpedite,
        intervention: offer.intervention,
        hasUnlimitedInterventions: offer.hasUnlimitedInterventions,
      })
    );
    const offerCompany = companies.find((c) => c.id == offer.companyId);
    dispatch(updateField({ field: 'company', value: offerCompany }));
    dispatch(updateField({ field: 'companyId', value: offerCompany?.id }));
    const fieldsValue = {
      ...form.getFieldsValue(true),
      isExpedite: offer.isExpedite,
    };
    form.setFieldsValue(fieldsValue);

    dispatch(updateEquipmentTab({ field: 'isOfferSelected', value: true }));
  };

  useEffect(() => {
    const isNewContract = id == null || id == undefined || id == '';
    const hasPrefilledData = !!reduxContract?.companyId || !!reduxContract?.registrationNumber;

    if (isNewContract && !hasPrefilledData) {
      const currentDate = new Date().toISOString().split('T')[0];
      const oneYearLater = new Date();
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
      const formattedOneYearLater = oneYearLater.toISOString().split('T')[0];

      dispatch(updateField({ field: 'enumContractStatusId', value: 1 }));
      dispatch(updateField({ field: 'date', value: currentDate }));
      dispatch(updateField({ field: 'dateStart', value: currentDate }));
      dispatch(updateField({ field: 'dateEnd', value: formattedOneYearLater }));
      dispatch(updateField({ field: 'datePeriod', value: 365 }));
      dispatch(updateField({ field: 'acquisitionType', value: 'transfer bancar' }));

      form.setFieldsValue({
        ...initialValues,
      });
    }
  }, [id, reduxContract?.companyId, reduxContract?.registrationNumber]);

  useEffect(() => {
    if (companyId) {
      const company = companies.find((company: any) => company.id === companyId);
      form.setFieldsValue({
        company: company,
        companyId: company?.id,
        accountManager: company?.accountManager,
      });
      dispatch(updateField({ field: 'companyId', value: company?.id ?? null }));
      dispatch(updateField({ field: 'company', value: company ?? null }));
      form.setFieldsValue({
        ...initialValues,
      });
      if (id == null || id == undefined || id == '') {
        handleSelectAccountSales(profile?.name!);
      }
    }
  }, [companies.length > 0]);

  useEffect(() => {
    const uniqueSystemTypeIds = Array.from(
      new Set(reduxContract.contractWorkPlaceItems.filter((c: any) => c.systemTypeId).map((c: any) => c.systemTypeId))
    );

    dispatch(updateField({ field: 'intervention', value: uniqueSystemTypeIds.length }));
    form.setFieldValue('intervention', uniqueSystemTypeIds.length);
  }, [reduxContract.contractWorkPlaceItems]);

  const onDateChange = (dateField: string, dateValue: string) => {
    dispatch(updateField({ field: dateField, value: dateValue }));
    form.setFieldsValue({ [dateField]: dateValue });

    reduxContract.contractWorkPlaceItems.forEach((item: any, index: number) => {
      if (dateField == 'dateEnd') {
        const isFutureDate = moment(dateValue).endOf('day').isAfter(moment());
        dispatch(
          updateContractWorkPlaceItem({
            index,
            updates: {
              ...item,
              dateEnd: dateValue,
              isActive: isFutureDate ? true : item?.isActive ?? false,
            },
          })
        );
      }
    });
  };

  const handleBlurClear = (fieldNames: string[]) => {
    fieldNames.forEach((field) => {
      form.setFieldsValue({ [field]: null });
      dispatch(updateField({ field, value: null }));
    });
  };

  return (
    <Form form={form} onValuesChange={handleFieldChange} layout='vertical' className='form-container'>
      <Row gutter={[16, 1]}>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['company', 'name']}
            label='Selectati Client'
            rules={[{ required: true, message: 'Alegeti un client!' }]}
          >
            <Select
              disabled={!!id}
              showSearch
              placeholder='Search and select a client'
              optionFilterProp='label'
              onSelect={(_value, option: any) => {
                handleSelectClient(option);
              }}
              onChange={() => handleBlurClear(['company', 'companyId'])}
              filterOption={(input, option) => {
                return option?.label?.toLowerCase()?.includes(input.toLowerCase());
              }}
              options={companies?.map((company: any) => ({
                value: company?.id,
                label: company?.name,
              }))}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountManager', 'name']}
            label='Manager de cont'
            rules={[{ required: true, message: 'Alegeti un manager de cont!' }]}
          >
            <Input disabled={true} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            name={['accountSale', 'name']}
            label='Agent Vanzari'
            rules={[{ required: true, message: 'Alegeti un agent de vanzari!' }]}
          >
            <AutoComplete
              options={accountSales?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectAccountSales}
              onChange={() => handleBlurClear(['accountSale', 'accountSaleId'])}
              filterOption={(input, option: any) => option.value.toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>
        {(id == '' || id == undefined || id == null) && (
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item name={['offer', 'number']} label='Select Offer'>
              <AutoComplete onSelect={handleSelectClientOffer}>
                {offers?.data?.map((offer: any, index: any) => (
                  <Option key={index} value={offer?.number}>
                    {offer?.number}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item name={['enumContractStatus', 'name']} label='Status'>
            <AutoComplete
              options={status?.map((item: any) => ({ value: item?.name }))}
              onSelect={handleSelectStatus}
              onChange={() => handleBlurClear(['enumContractStatus', 'enumContractStatusId'])}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8}>
          <Form.Item
            label='Numar de Inregistrare'
            name='registrationNumber'
            rules={[{ required: true, message: 'Introduceti numarul de inregistrare!' }]}
          >
            <Input onChange={(e) => dispatch(updateField({ field: 'registrationNumber', value: e.target.value }))} />
          </Form.Item>
        </Col>
        <Divider />
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Contract'
            name='date'
            rules={[{ required: true, message: 'Introduceti data contract!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('date', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Inceput'
            name='dateStart'
            rules={[{ required: true, message: 'Introduceti data inceput!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateStart', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Data Sfarsit'
            name='dateEnd'
            rules={[{ required: true, message: 'Introduceti data sfarsit!' }]}
          >
            <Input type='date' min={currentDate} onChange={(e) => onDateChange('dateEnd', e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item
            label='Achizitie'
            name='acquisitionType'
            rules={[
              {
                required: true,
                message: 'Introduceticeti tipul de achizitie!',
              },
            ]}
          >
            <Select>
              <Select.Option value='numerar'>Numerar</Select.Option>
              <Select.Option value='cash'>Cash</Select.Option>
              <Select.Option value='transfer bancar'>Transfer Bancar</Select.Option>
              <Select.Option value='bilet la ordin'>Bilet la Ordin</Select.Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label='Obervatii' name='remarks'>
            <TextArea />
          </Form.Item>
        </Col>
        {/* {!reduxContract.hasUnlimitedInterventions && (
          <Col xs={24} sm={12} md={8}>
            {(!id || !reduxContract.hasUnlimitedInterventions) && (
              <Form.Item
                label='Intervenții Corective'
                name='intervention'
                initialValue={3}
                rules={[
                  {
                    required: true,
                    message: 'Introduceți numărul de intervenții corective!',
                  },
                ]}
              >
                <InputNumber disabled={!!id} style={{ width: '100%' }} />
              </Form.Item>
            )}
          </Col>
        )}
        {(!id || reduxContract.hasUnlimitedInterventions) && (
          <Col xs={24} sm={12} md={8}>
            <Form.Item label='Intervenții Nelimitate' name='hasUnlimitedInterventions' valuePropName='checked'>
              <Checkbox
                disabled={!!id}
                onChange={(e) => {
                  handleChangeUnlimitedInterventions(e.target.checked);
                  if (e.target.checked) {
                    form.setFieldsValue({ intervention: undefined });
                  }
                }}
              />
            </Form.Item>
          </Col>
        )} */}
        <Col xs={24} sm={12} md={8} lg={4}>
          <Form.Item label='Urgent' name='isExpedite' valuePropName='checked'>
            <Checkbox onChange={(e) => dispatch(updateField({ field: 'isExpedite', value: e.target.checked }))} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={4}>
          <Form.Item label='Prelungire automata' name='hasAutomaticExtension' valuePropName='checked'>
            <Checkbox
              disabled={reduxContract.enumContractStatus?.id == 4}
              onChange={(e) => dispatch(updateField({ field: 'hasAutomaticExtension', value: e.target.checked }))}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CompanyDetailsTab;
